import { useCallback } from 'react';
import type { Variant } from 'types/entity/product';
import { ColorGroupCodeDot } from '../colors/ColorGroupCodeDot';

type Props = {
  index: number;
  variant: Variant;
  onClick: (params: { index: number; variant: Variant }) => void;
};

const ColorGroupCodeVariantPickerDot: React.FC<
  Props & Omit<React.ComponentProps<typeof ColorGroupCodeDot>, keyof Props>
> = ({ index, variant, onClick, ...rest }) => {
  const handleClick = useCallback<React.MouseEventHandler>(
    (e) => {
      e.preventDefault();
      onClick({ variant, index });
    },
    [index, variant, onClick],
  );
  return <ColorGroupCodeDot {...rest} onClick={handleClick} />;
};

export default ColorGroupCodeVariantPickerDot;
